import React, { useState, useEffect } from "react";

import "./LoginPage.css";
import { Formik } from 'formik';
import axios from 'axios';
import { site_url } from "../config.js";
import { resolveReferralRefFromQuery } from "../referralRefCrypto.js";
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { useLocation } from "react-router-dom";

function Index() {
  const [msg, setMsg] = useState([]);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Remove modal backdrops
    const backdrops = document.querySelectorAll(".modal-backdrop");
    backdrops.forEach((el) => el.remove());

    // Remove modal-open class
    document.body.classList.remove("modal-open");

    // Remove inline styles like overflow and padding
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";

    // Optionally, clear all inline styles (use with caution)
    // document.body.removeAttribute("style");
  }, [location]);
  const showModal = (modalId) => {
    if (window.bootstrap) {
      const modalElement = document.getElementById(modalId);
      if (modalElement) {
        const modal = new window.bootstrap.Modal(modalElement);
        modal.show();
      }
    }
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    console.log(values);

    const ref = await resolveReferralRefFromQuery(searchParams.get('ref'));

    const data = {
      phone: values.phone,
      username: values.username,
      email: values.email,
      ref: ref
    }
    try {

      const response = await axios.post(site_url + '/create_account', data);

      if (response.data.status === 'success') {
        setMsg({ status: 'success', message: 'Account Successfully Created!' });

        showModal('actionSheetAlertSuccess');

        setTimeout(() => {
          navigate('/signin', { state: { phone: values.phone } });
        }, 1500);

        resetForm();
      } else if (response.data.status === 'failed') {
        setMsg(response.data);
        showModal('actionSheetAlertError');
      }
      // Reset form after success
    } catch (error) {
      console.error(error);
      setMsg({ status: 'failed', message: 'An error occurred.' });
      showModal('actionSheetAlertError');
    } finally {
      setSubmitting(false); // Stop loading spinner
    }
  };

  return (
    <div className="login-container">
      <div className="login-header">
        <img
          src="digital-marketing.jpg" // Replace with your truck image URL
          alt="Truck"
          className="header-image"
        />
      </div>
      <div className="login-form">
        <Formik
          initialValues={{ phone: '', username: '', email: '' }}
          validate={values => {
            const errors = {};
            if (!values.phone) {
              errors.phone = 'Phone Number is required';
            } else if (!/^\d{10}$/.test(values.phone)) {
              errors.phone = 'Phone number must be exactly 10 digits';
            }

            if (!values.username) {
              errors.username = 'Username is required';
            }
            return errors;
          }}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit}>
              <h2>Create a New Account</h2>
              {/* Bootstrap alerts are now secondary to Modals but kept for fallback or immediate feedback */}
              {msg.status === 'success' && (
                <div class="alert alert-success mb-1" role="alert">
                  {msg.message}
                </div>
              )}
              {msg.status === 'failed' && (
                <div class="alert alert-danger mb-1" role="alert">
                  {msg.message || 'Phone number already exists'}
                </div>
              )}

              <div className="form-group">
                <label htmlFor="Username">
                  <i className="fa fa-user"></i>
                </label>
                <input type="text" id="text" placeholder="Enter Your Name" name="username" onChange={handleChange} onBlur={handleBlur} value={values.username} />
              </div>
              {errors.username && touched.username && (<span className="error">{errors.username}</span>)}
              <div className="form-group">
                <label htmlFor="Username">
                  <i className="fa fa-envelope"></i>
                </label>
                <input type="email" placeholder="Enter Your Email Id" name="email" onChange={handleChange} onBlur={handleBlur} value={values.email} />
              </div>
              <div className="form-group">
                <label htmlFor="email">
                  <i className="fa fa-phone"></i>
                </label>
                <input type="number" id="email" placeholder="Enter Your Mobile Number" name="phone" onChange={handleChange} onBlur={handleBlur} value={values.phone} />
              </div>
              {errors.phone && touched.phone && (<span className="error">{errors.phone}</span>)}
              <button type="submit" disabled={isSubmitting} className="login-button">{isSubmitting ? 'Submitting...' : 'Sign up'}</button>

            </form>
          )}
        </Formik>
      </div>

      {/* Action Sheet Alert - Success */}
      <div className="modal fade action-sheet" id="actionSheetAlertSuccess" tabIndex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <div className="action-sheet-content">
                <div className="icon-box text-success">
                  <ion-icon name="checkmark-circle"></ion-icon>
                </div>
                <div className="text-center">
                  <h3>Success</h3>
                  <p>{msg.message}</p>
                </div>
                <a href="#" className="btn btn-primary btn-block btn-lg" data-bs-dismiss="modal">OK</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Action Sheet Alert - Error */}
      <div className="modal fade action-sheet" id="actionSheetAlertError" tabIndex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <div className="action-sheet-content">
                <div className="icon-box text-danger">
                  <ion-icon name="close-circle"></ion-icon>
                </div>
                <div className="text-center">
                  <h3>Error</h3>
                  <p>{msg.message}</p>
                </div>
                <a href="#" className="btn btn-primary btn-block btn-lg" data-bs-dismiss="modal">OK</a>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default Index;
